module.exports = __webpack_public_path__ + "static/media/boat-img-13.43bf2eb4.jpg";